import { Btn, Field, inputCls } from "@/components/common";
import { eur } from "@/lib/api";
import { SUBS, CURRENCIES, EXTRA_SUGGESTIONS, toEur } from "@/lib/expenseConstants";

export function ExpenseForm({ form, set, rates, flags, editId, onSubmit, onCancel, subs }) {
  const { hasSub, hasFrequency, hasExtra, isStaff } = flags;
  const subList = subs && subs.length ? subs : SUBS;
  return (
    <form onSubmit={onSubmit} className={isStaff ? "grid grid-cols-1 sm:grid-cols-2 gap-4" : "space-y-4"} data-testid="expense-form">
      {isStaff && (
        <>
          <Field label="Nome dipendente">
            <input value={form.staff_name} onChange={(e) => set("staff_name", e.target.value)} className={inputCls} data-testid="exp-staffname" />
          </Field>
          <Field label="Ruolo">
            <input value={form.role} onChange={(e) => set("role", e.target.value)} className={inputCls} data-testid="exp-role" />
          </Field>
          <Field label="Data inizio">
            <input type="date" value={form.start_date} onChange={(e) => set("start_date", e.target.value)} className={inputCls} data-testid="exp-start" />
          </Field>
          <Field label="Data fine">
            <input type="date" value={form.end_date} onChange={(e) => set("end_date", e.target.value)} className={inputCls} data-testid="exp-end" />
          </Field>
        </>
      )}
      <Field label="Data registrazione">
        <input type="date" required value={form.date} onChange={(e) => set("date", e.target.value)} className={inputCls} data-testid="exp-date" />
      </Field>
      {hasSub && (
        <Field label="Categoria">
          <select value={form.subcategory} onChange={(e) => set("subcategory", e.target.value)} className={inputCls} data-testid="exp-sub">
            {subList.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </Field>
      )}
      {hasFrequency && (
        <Field label="Frequenza">
          <select value={form.frequency} onChange={(e) => set("frequency", e.target.value)} className={inputCls} data-testid="exp-frequency">
            <option value="una_tantum">Puntuale (solo questo mese)</option>
            <option value="mensile">Ricorrente ogni mese</option>
          </select>
        </Field>
      )}
      {hasExtra && (
        <Field label="Extra (opzionale)">
          <input list="extra-list" value={form.extra} onChange={(e) => set("extra", e.target.value)} className={inputCls} data-testid="exp-extra" placeholder="Es. Work permit, Ramadan bonus" />
          <datalist id="extra-list">{EXTRA_SUGGESTIONS.map((s) => <option key={s} value={s} />)}</datalist>
        </Field>
      )}
      <Field label="Descrizione">
        <input value={form.description} onChange={(e) => set("description", e.target.value)} className={inputCls} data-testid="exp-desc" />
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Importo">
          <input type="number" step="0.01" required value={form.amount} onChange={(e) => set("amount", e.target.value)} className={inputCls} data-testid="exp-amount" />
        </Field>
        <Field label="Valuta">
          <select value={form.currency} onChange={(e) => set("currency", e.target.value)} className={inputCls} data-testid="exp-currency">
            {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </Field>
      </div>
      {form.currency !== "EUR" && (
        <p className="text-xs text-slate-500 -mt-1">≈ {eur(toEur(form.amount, form.currency, rates))} al cambio attuale</p>
      )}
      <div className={`flex justify-end gap-2 pt-2 ${isStaff ? "sm:col-span-2" : ""}`}>
        <Btn type="button" variant="secondary" onClick={onCancel}>Annulla</Btn>
        <Btn type="submit" data-testid="save-expense">Salva</Btn>
      </div>
    </form>
  );
}
